/**
 * src/shared/utils/track.js
 *
 * Registro de clicks/visitas a negocios y promos.
 * Envía un beacon a /api/click.php (PHP en el hosting).
 *
 * - Solo cuenta en producción (en dev no hay PHP).
 * - sendBeacon no bloquea la navegación ni afecta la velocidad.
 * - Evita contar dos veces la misma visita en la misma sesión.
 */

/**
 * @param {'business'|'promo'} type
 * @param {number|string} id
 */
export function trackClick(type, id) {
    if (!import.meta.env.PROD) return
    if (!id) return

    // No contar repetido en la misma sesión del navegador
    const key = `tracked-${type}-${id}`
    if (sessionStorage.getItem(key)) return
    sessionStorage.setItem(key, '1')

    const url = `/api/click.php?type=${type}&id=${id}`
    if (navigator.sendBeacon) {
        navigator.sendBeacon(url)
    } else {
        fetch(url).catch(() => {})
    }
}
